// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".application{padding-bottom:60px;margin:0 auto}@media only screen and (min-width:992px){.application{padding-bottom:100px}}.application__section{margin:40px 0;padding:16px;border-radius:20px}.application__section:first-child{margin-top:30px}@media only screen and (min-width:992px){.application__section{margin:56px 0;padding:40px;border-radius:25px}.application__section:first-child{margin-top:40px}}", ""]);
// Exports
module.exports = exports;
